import { ref, computed, type Ref } from 'vue';

function readLocalStorage(key: string): boolean {
  try {
    return localStorage.getItem(key) === 'true';
  } catch {
    return false;
  }
}

function writeLocalStorage(key: string) {
  try {
    localStorage.setItem(key, 'true');
  } catch {
    // storage full or blocked
  }
}

const flags = new Map<string, Ref<boolean>>();

function getFlag(storageKey: string): Ref<boolean> {
  let flag = flags.get(storageKey);
  if (!flag) {
    flag = ref(readLocalStorage(storageKey));
    flags.set(storageKey, flag);
  }
  return flag;
}

/**
 * Persistent dismiss/seen flag backed by localStorage: active until
 * `markDone()` is called. Backed by a module-singleton ref per `storageKey`
 * so every caller (e.g. multiple mounted instances of the same tab/component)
 * shares state.
 */
export function useDismissFlag(storageKey: string) {
  const done = getFlag(storageKey);

  const isActive = computed(() => !done.value);

  function markDone() {
    done.value = true;
    writeLocalStorage(storageKey);
  }

  return { isActive, markDone };
}
